import { VideoType } from 'types/api/TestAttempt';

export const KALTURA_PARTNER_ID = 966871;

export const VIDEO_TYPES: Record<string, VideoType> = {
  PRACTICE: 'practice',
  RELIABILITY: 'reliability',
  TRAINING: 'training',
  CALIBRATION: 'calibration'
};
